<template>
  <SysDialogFullScreen v-model="dialog" :titulo="TITULO_DIALOG">
    <table style="width: 100%; padding: 0 10px;">
      <template v-for="(linha, index) in LINHAS">
        <LinhaTabelaDetalhesProdutos
          :linha="linha"
          :dados="dados_detalhe"
          :key="index"
          :maximoDeColunas="maximoDeColunas"
        >
          <template #coluna.valor.nivel_estoque="{valor}">
            <NivelEstoqueProgressCircular :valor="valor" />
          </template>
        </LinhaTabelaDetalhesProdutos>
      </template>
    </table>

    <div class="chart-evento-sazonalidade">
      <Grafico :dados="dados_grafico"  @atualizar-detalhes="buscarDadosDetalhe($event)"/>
    </div>
  </SysDialogFullScreen>
</template>

<script>
  import Api from '@/api/api';
  import { mapGetters } from 'vuex';
  import Grafico from './Grafico.vue';
  import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue';
  import LinhaTabelaDetalhesProdutos from '@/components/produto/detalhes/LinhaTabelaDetalhesProdutos.vue';
  import NivelEstoqueProgressCircular from '@/components/produto/detalhes/NivelEstoqueProgressCircular.vue';

  export default {
    components: {
      Grafico,
      SysDialogFullScreen,
      LinhaTabelaDetalhesProdutos,
      NivelEstoqueProgressCircular,
    },
    data: () => ({
      dialog: false,
      maximoDeColunas: 5,
      dados_grafico: {},
      dados_detalhe: {},
    }),
    props: {
      produto: {
        type: Object,
        required: true
      }
    },
    watch: {
      produto() {
        this.dialog = !this.dialog;

        if (this.dialog) {
          this.buscarDadosDetalhe();
          this.buscarDadosGrafico();
        }
      }
    },
    computed: {
      ...mapGetters({
        GET_FORM_NOVO_EVENTO: 'EventoSazonalFinal/GET_FORM_NOVO_EVENTO',
      }),
      TITULO_DIALOG() {
        return 'Detalhe do Produto no Evento: ' + this.GET_FORM_NOVO_EVENTO.nome_evento;
      },
      LINHAS() {
        return [
          {
            colunas: [
              { texto: 'Preço de Compra', valor: 'preco_compra', formatarDinheiro: true },
              { texto: 'Ressuprimento', valor: 'ressuprimento', formatar: true, append: 'dias' },
              { texto: 'Lote Mínimo', valor: 'lote_minimo', formatar: true },
            ]
          },
          { divider: true, titulo: 'Estoques e coberturas' },
          {
            colunas: [
              { texto: 'Nível Estoque', valor: 'nivel_estoque', rowspan: 2 },
              { texto: 'Saldo Estoque', valor: 'estoque', formatar: true },
              { texto: 'Estoque Segurança', valor: 'esseg', formatar: true },
              { texto: 'Ponto Pedido', valor: 'ppd', formatar: true },
              { texto: 'Estoque Máximo', valor: 'emax', formatar: true },
            ]
          },
          {
            colunas: [
              { texto: 'Cobertura Estoque', valor: 'cobertura_estoque', formatar: true, append: 'dias' },
              { texto: 'Cobertura Eseg', valor: 'cobertura_esseg', formatar: true, append: 'dias' },
              { texto: 'Cobertura PP', valor: 'cobertura_ppd', formatar: true, append: 'dias' },
              { texto: 'Cobertura Emax', valor: 'cobertura_emax', formatar: true, append: 'dias' },
            ]
          },
          { divider: true, titulo: 'Média de venda nos últimos meses', nome: 'media-venda-ultimos-meses' },
          {
            colunas: [
              { texto: '3 meses', valor: 'trimestral', formatar: true },
              { texto: '6 meses', valor: 'semestral', formatar: true },
              { texto: '12 meses', valor: 'anual', formatar: true },
              { texto: 'Total Vendido', valor: 'cmm', formatar: true },
            ]
          },
          { divider: true, titulo: 'Raio X' }
        ];
      }
    },
    methods: {
      buscarDadosGrafico() {
        Api.post(`eventos-sazonais/produto/grafico`, this.produto)
          .then((response) => this.dados_grafico = response.data.dados)
          .catch(this.Helpers.logout)
      },
      buscarDadosDetalhe(e) {
        if (e != undefined) {
          this.produto['data_inicial'] = e[0];
          this.produto['data_final'] = e[1];
        }

        Api.post(`eventos-sazonais/produto/detalhe`, this.produto)
          .then((response) => this.dados_detalhe = response.data.dados)
          .catch(this.Helpers.logout)
      }
    },
  }
</script>

<style>
  .chart-evento-sazonalidade {
    height: calc(100vh - 290px) !important;
  }
</style>
